import {UserRole} from '../utils/enumUtils';

const initialState = {
    data: {},
    allDefaultCategories:[],
    userRegionDefaultCategories:[],
    userCategories: [],
    userRole: UserRole.DJ,
    userRegion: "",
    error: null
};

export default function (state = initialState, action) {

    switch (action.type) {
        case "LOGIN_FULFILLED":
        case "RESTORE_SESSION_FULFILLED":
        case "REGISTER_FULFILLED":   {
            return {
                ...state,
                userCategories: getUserCategories(action.payload.data.recCategories, state.allDefaultCategories),
                userRole: action.payload.data.role,
                userRegion: action.payload.data.region
            }
        }

        case "GET_DEFAULT_RECOMMENDATIONS_CATEGORIES_FULFILLED": {
            if (state.userRole === UserRole.VIBO_ADMIN) {
                return state;
            }
            let allDefaultCategories =
                action.payload.data.filter((category) => !category.isDeleted).map(
                    (category) => {category.isDefault = true; return category} );
            sortArrayByTitle(allDefaultCategories);
            let userRegionDefaultCategories = allDefaultCategories.filter(
                (category) => !(category.supportedLocales)  ||
                    category.supportedLocales.some((locale) => locale === state.userRegion));
            sortArrayByTitle(userRegionDefaultCategories);
            return {
                ...state,
                userCategories: getUserCategories(state.userCategories, allDefaultCategories),
                allDefaultCategories: allDefaultCategories,
                userRegionDefaultCategories: userRegionDefaultCategories
            }
        }

        case "UPDATE_CATEGORY_RECOMMENDATION_SONGS": {
            let newData = Object.assign({}, state.data);
            let isDefault = isDefaultCategory(action.payload.data.category, state.allDefaultCategories);
            let songs = action.payload.data.songs;
            sortArrayByPosition(songs);
            newData[action.payload.data.category] = {
                songs:songs,
                lastPosition:action.payload.data.lastPosition,
                isDefault: isDefault,
                isEditable: isEditableCategory(isDefault)
            };

            return {
                ...state,
                data: newData,
            }
        }

        case "CHANGE_SONG_POSITION": {
            let newData = Object.assign({}, state.data);
            let songs = newData[action.payload.categoryId].songs;
            setNewPositions(songs, action.payload.oldIndex, action.payload.newIndex);
            sortArrayByPosition(songs);
            newData[action.payload.categoryId].songs = songs;
            return {
                ...state,
                data: newData
            }
        }

        case "SAVE_SONG_TO_BE_DELETED": {
            return {
                ...state,
                songToBeDeleted: action.payload,
            }
        }

        case "DELETE_SONG_FULFILLED": {
            let newData = Object.assign({}, state.data);
            newData[state.songToBeDeleted.genre].songs =
                state.data[state.songToBeDeleted.genre].songs.filter(item => item.objectId !== state.songToBeDeleted.objectId);

            return {
                ...state,
                data: newData
            }
        }

        case "IMPORT_SPOTIFY_PLAYLIST_PENDING": {
            return {
                ...state,
                importedFromSpotify: false,
            }
        }

        case "IMPORT_SPOTIFY_PLAYLIST_FULFILLED": {
            const viboPlaylistId = action.payload.data.viboPlaylistId;
            let addedSongs = action.payload.data.addedSongs;
            const numberOfImportedSongs = addedSongs.length;
            const newData = Object.assign({}, state.data);

            if(numberOfImportedSongs) {
                addedSongs = addedSongs.map(addedSong => (JSON.parse(addedSong)));

                if (!(newData[viboPlaylistId])) {
                    newData[viboPlaylistId] = {songs: []}
                }

                newData[viboPlaylistId].lastPosition = action.payload.data.lastPosition;
                newData[viboPlaylistId].songs = newData[viboPlaylistId].songs.concat(addedSongs);
            }

            return {
                ...state,
                data:                   newData,
                importedFromSpotify:    true,
                numberOfImportedSongs,
                wereAllSongsImported:   action.payload.data.wereAllSongsImported,
            }
        }

        case "ADD_SONG_FULFILLED": {
            var addedSong = action.payload.data.newestSong;
            let newData = Object.assign({}, state.data);
            if (!(newData[addedSong.genre])) {
                newData[addedSong.genre] = {songs:[]}
            }
            newData[addedSong.genre].songs = newData[addedSong.genre].songs.concat(addedSong);
            newData[addedSong.genre].lastPosition = addedSong.position;

            return {
                ...state,
                data: newData,
            }
        }

        case "ADD_CATEGORY_FULFILLED":
        case "DELETE_CATEGORY_FULFILLED":
        case "EDIT_CATEGORY_FULFILLED":
        case "CLONE_CATEGORY_FULFILLED":
        {
            return {
                ...state,
                userCategories: getUserCategories(action.payload.data.recCategories, state.allDefaultCategories, state.userRole)
            }
        }

        default:
            return state;
    }
}

function getUserCategories(categories, allDefaultCategories, userRole) {
    let userCategories = categories ? categories.filter(
        category => !(category.isDeleted || isDefaultCategory(category.id, allDefaultCategories))) : [];
    userCategories.forEach((category) => {
        category.isDefault = false;
        category.isEditable = isEditableCategory(category.isDefault, userRole);
    });
    sortArrayByTitle(userCategories);
    return userCategories;
}

function sortArrayByTitle(arr) {
    arr.sort(function (a, b) {
        if (!a.title) {
            return -1;
        }
        if (!b.title) {
            return 1;
        }
        return a.title.localeCompare(b.title);
    });
}

function isDefaultCategory(categoryId, allDefaultCategories) {
    let id = categoryId.toString();
    return (allDefaultCategories.some((defaultCategory) => defaultCategory.id.toString() === id));
}

function isEditableCategory(isDefaultCategory, userRole) {
    return !isDefaultCategory || (userRole === UserRole.VIBO_ADMIN);
}

function sortArrayByPosition(arr) {
    arr.sort(function (a, b) {
        if (!a.position) {
            return -1;
        }
        if (!b.position) {
            return 1;
        }
        return a.position - b.position;
    });
}

function setNewPositions(songs, oldIndex, newIndex) {
    let addition = (oldIndex - newIndex)/(Math.abs(oldIndex - newIndex));
    let startingIndex = oldIndex < newIndex ? oldIndex + 1 : newIndex;
    let endingIndex = oldIndex < newIndex ? newIndex : oldIndex - 1;
    songs[oldIndex].position = songs[newIndex].position;
    for (let i = startingIndex; i <= endingIndex; i++) {
        songs[i].position = (i === oldIndex ? newIndex : songs[i].position + addition);
    }
}


// WEBPACK FOOTER //
// ./src/reducers/recommendationsReducer.js